import React, { Component } from 'react';
import { getTranslation } from '../Utilities/GetTranslation';
declare var $;

class FormList extends Component {
    handleDelete(id, e) {
        e.preventDefault();
        this.props.onDelete(id);
    }

    handleEdit(id, e) {
        e.preventDefault();
        this.props.onEdit(id);
    }

    render() {
        if (this.props.values.length < 1) {
            return "";
        }

        let tableClass = "tr table-wrapper" + ((this.props.isUserData) ? " userdata" : "");
        let editClass = (this.props.editClass) ? this.props.editClass : "fa fa-pencil";
        let title = (this.props.title) ? <strong>{this.props.title}</strong> : "";

        return (
            <div className={tableClass}>
                {title}
                <table className="table table-condensed table-responsive">
                    <tbody>
                        {
                            this.props.values.map((value) =>
                                <tr key={value.id} className={this.props.highlightId === value.id ? "alert alert-info" : value.rowClass}>
                                    <td>{value.text}</td>
                                    <td className="text-right">
                                        {
                                            (this.props.showEdit) ? 
                                            <a href="# " onClick={(e) => this.handleEdit(value.id, e)}>
                                                <span className="sr-only">{getTranslation("sns.general.screenreader.edit")}</span><i className={value.editClass ? value.editClass : editClass} aria-hidden="true"></i>
                                            </a> :
                                            ""
                                        }
                                        {
                                            (this.props.showDelete) ?
                                            <a href="# " onClick={(e) => this.handleDelete(value.id, e)}>
                                                <span className="sr-only">{getTranslation("sns.general.screenreader.delete")}</span><i className="fa fa-trash-o" aria-hidden="true"></i>
                                            </a> :
                                            ""
                                        }
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
        );
    }
}

export default FormList;


// WEBPACK FOOTER //
// ./src/Fields/FormList.js